const Show = ({condition, children}) => {
    return !!condition && children;
}

export default Show;


// WEBPACK FOOTER //
// ./src/utils/show.component.js